import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children, allowedRoles = [] }) => {
  const { currentUser, userData } = useAuth();

  if (!currentUser) {
    return <Navigate to="/" />;
  }

  // Check if user is approved
  if (!userData?.approved) {
    return (
      <div style={{ 
        padding: '40px', 
        textAlign: 'center',
        maxWidth: '600px',
        margin: '0 auto'
      }}>
        <h2>Account Pending Approval</h2>
        <p>Your account is currently pending approval from an administrator. You will be notified once your account has been approved.</p>
        <p>Please contact your administrator if you need immediate access.</p>
      </div>
    );
  }

  // If no roles specified, allow access (for backward compatibility)
  if (allowedRoles.length === 0) {
    return children;
  }

  // Check if user's role is allowed
  if (!userData?.role || !allowedRoles.includes(userData.role)) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

export default PrivateRoute; 